<template>
  <div class='wrapper-page'>
    <copy-shared-record-form ref='copySharedRecordForm' @success="loadSharedFolder()" />
    <folder-subscription-modal ref="folderSubscriptionModal" v-on:reload-callback="loadSharedFolder()" />
    <bulk-copy-records-form ref="bulkCopyRecords" @success="loadSharedFolder()"></bulk-copy-records-form>
    <bulk-records-tags-modal ref='bulkTagItemsModal' :shared-folder="sharedFolder" @success='loadSharedFolder()' />
    <modal ref='uploadModal' v-if="permission === 'write' || permission === 'all'">
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('upload_files_modal.upload_files') }}</h5>
      </template>

      <template #body>
        <div class='modal-body'>
          <dropzone ref='dropzone' :successCallback='uppySuccessCallback' :completeCallback='uppyCompleteCallback' />
        </div>
      </template>
    </modal>

    <modal ref='deleteModal'>
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('folder_show.modals.delete_file.title') }}</h5>
      </template>

      <template #body>
        <form @submit.prevent='deleteFile($event)'>
          <div class='modal-body'>
            <p>{{ $t('folder_show.modals.delete_file.label') }}</p>
          </div>

          <div class='modal-footer'>
            <input type='submit' :value="$t('folder_show.modals.delete_file.submit')" class='btn btn-danger' />
            <input @click.prevent='$refs.deleteModal.close' type='submit' :value="$t('folder_show.modals.delete_file.cancel')" class='btn btn-outline-primary'>
          </div>
        </form>
      </template>
    </modal>
    <modal ref='deleteBulkModal'>
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('records_list.delete_files', {number: bulkOpRecords.length}) }}</h5>
      </template>

      <template #body>
        <form @submit.prevent='deleteBulkFile($event)'>
          <div class='modal-body'>
            <p>{{ $t('records_list.remove_files_descr') }}</p>
          </div>

          <div class='modal-footer'>
            <input type='submit' :value="$t('records_list.remove_files')" class='btn btn-danger' />
            <input @click.prevent='$refs.deleteBulkModal.close' type='submit' :value="$t('folder_show.modals.delete.cancel')" class='btn btn-outline-primary'>
          </div>
        </form>
      </template>
    </modal>

    <modal ref='renameModal'>
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('records_list.dropdown.rename') }}</h5>
      </template>

      <template #body>
        <form @submit.prevent='renameFile($event)'>
          <div class='modal-body'>
            <label>{{ $t('records_list.file_name') }}</label>
            <input type='text' name='shared_record[filename]' class='form-control' v-model='selectedRecord.filename'/>
          </div>

          <div class='modal-footer'>
            <input type='submit' :value="$t('records_list.dropdown.rename')" class='btn btn-primary' />
          </div>
        </form>
      </template>
    </modal>
    <modal ref='renameBulkModal'>
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('records_list.rename_to_folder', {number: bulkOpRecords.length})}}</h5>
      </template>

      <template #body>
        <form @submit.prevent='bulkRenameFiles($event)'>
          <div class='modal-body'>
            <label>{{ $t('records_list.file_name') }}</label>
            <input type='text' name='shared_record[filename]' class='form-control' v-model='bulkFilenameRename'/>
          </div>

          <div class='modal-footer'>
            <input type='submit' :value="$t('records_list.rename_files')" class='btn btn-primary' />
          </div>
        </form>
      </template>
    </modal>

    <modal ref='filterModal' class="filter-all-records">
      <template #header>
        <h5 class="modal-title mt-0">{{ $t('folders_list.share_folder_by') }}</h5>
      </template>
      <template #body>
        <form>
          <div class='modal-body'>
            <div class="form-group">
              <label>
                {{ $t('records_list.filename') }}
              </label>
              <PinkCatSelect
                      :options-for-select="recordsForSelect"
                      :selected-filters="selectedRecords"
                      :template="recordTemplate"
                      :single-select="false"
                      @add="addRecord"
                      @remove="removeRecord"
                      @clearSelectedOption="clearOptionForRecords"/>
            </div>
            <div class="form-group">
              <label>
                {{ userDocumentTypeTitle }}
              </label>
              <PinkCatSelect
                      :options-for-select="documentTypes"
                      :selected-filters="selectedDocumentTypes"
                      :template="documentTypeTemplate"
                      :single-select="false"
                      @add="addDocumentType"
                      @remove="removeDocumentType"
                      @clearSelectedOption="clearOptionForDocumentType"/>
            </div>
            <div class="form-group">
              <label>
                {{ userProductTitle }}
              </label>
              <PinkCatSelect
                      :options-for-select="products"
                      :selected-filters="Object.values(selectedProducts)"
                      :template="documentTypeTemplate"
                      :single-select="false"
                      @add="addProduct"
                      @remove="removeProduct"
                      @clearSelectedOption="clearOptionForProducts"/>
            </div>
            <div class="form-group">
              <label>
                {{ userProductTitle }} {{ userProductCode }}
              </label>
              <PinkCatSelect
                  :options-for-select="products.filter(p => p.code)"
                  :selected-filters="Object.values(selectedProductsCode)"
                  :template="productCodeTemplate"
                  :single-select="false"
                  @add="addProductCode"
                  @remove="removeProductCode"
                  @clearSelectedOption="clearOptionForProductsCode"/>
            </div>
            <div class="form-group">
              <label>
                {{ $t('records_list.filters.tags') }}
              </label>
              <PinkCatSelect
                      :options-for-select="tags"
                      :selected-filters="Object.values(selectedTags)"
                      :template="documentTypeTemplate"
                      :single-select="false"
                      @add="addTag"
                      @remove="removeTag"
                      @clearSelectedOption="clearOptionForTags"/>
            </div>
            <div class="form-group">
              <label>
                {{ $t('records_list.table.expiration_status') }}
              </label>
              <PinkCatSelect
                      :options-for-select="expStatus"
                      :selected-filters="Object.values(selectedExpStatus)"
                      :template="documentTypeTemplate"
                      :single-select="false"
                      @add="addExpStatus"
                      @remove="removeExpStatus"
                      @clearSelectedOption="clearOptionForExpStatus"/>
            </div>
            <div class="form-group">
              <label>
                {{ $t('records_list.table.expiration') }}
              </label>
              <datepicker
                      v-model="selectedExpiration"
                      input-class="form-control expiration-input"
                      :typeable="true"
                      :full-month-name="true"
                      :monday-first="true"
                      :placeholder="$t('expiration.pick_date')">
              </datepicker>
            </div>
            <div class='modal-footer'>
              <input @click.prevent='clearFilter' type='reset' class="btn btn-neutral float-right" :value="$t('folders_list.clear_filters')" />
              <button type='submit' class="btn btn-outline-primary float-right" @click.prevent="filterRecords">{{ $t('folders_list.filter') }}</button>
            </div>
          </div>
        </form>
      </template>
    </modal>

    <div class='container-fluid'>
      <h1 class='page-title'>
        {{ fullName }} > <strong>{{ folderName }} ({{ records.length  }})</strong>
      </h1>
      <div class='clearfix'></div>

      <div class="dropdown btn-group float-right m-r-10" role="group" aria-expanded="false">
        <button class="btn btn-neutral dropdown-toggle" aria-expanded="false" aria-haspopup="true" data-toggle="dropdown">
          {{ $t('folder_show.activities.actions') }}
        </button>

        <div class="dropdown-menu dropdown-menu-right">
          <ul>
            <li>
              <a @click.prevent="$refs.folderSubscriptionModal.open(sharedFolder, true)" href="#" class="dropdown-item" v-if="sharedFolder">
                <i class="fas fa-folder-plus"></i>
                <span v-if='sharedFolder.subscription && sharedFolder.subscription.id'>{{ $t('folder_show.activities.unsubscribe_from_folder') }}</span>
                <span v-else>{{ $t('folder_show.activities.subscribe_to_folder') }}</span>
              </a>
            </li>
            <li>
              <a @click.prevent='$refs.uploadModal.open' href="#" class="dropdown-item" v-if="permission === 'write' || permission === 'all'">
                <i class="fas fa-upload"></i>
                {{ $t('upload_files_modal.upload_files') }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="permission-block float-right">
        <p>{{ $t('folder_show.permission') }}
          <strong v-if="permission === 'read'">{{ $t('share_invite.can_read') }}</strong>
          <strong v-if="permission === 'write'">{{ $t('share_invite.can_edit') }}</strong>
          <strong v-if="permission === 'all'">{{ $t('share_invite.can_edit_folder_options') }}</strong>
          <i class="fas fa-info-circle" @mouseover="permissionType"></i>
        </p>
        <div class="info-permission" v-if="permissionHoverRead">
          <i class="fas fa-times float-right" v-on:click="permissionHoverRead = false"></i>
          <p v-if="permission === 'read'">{{ $t('folder_show.view_perm') }}</p>
          <p>{{ $t('folder_show.learn_more') }} <a :href="helpCenterUrl" target="_blank">{{ $t('folder_show.check_out') }}</a></p>
        </div>
        <div class="info-permission" v-if="permissionHoverWrite">
          <i class="fas fa-times float-right" v-on:click="permissionHoverWrite = false"></i>
          <p v-if="permission === 'write'">{{ $t('folder_show.edit_perm') }}</p>
          <p>{{ $t('folder_show.learn_more') }} <a :href="helpCenterUrl" target="_blank">{{ $t('folder_show.check_out') }}</a></p>
        </div>
        <div class="info-permission" v-if="permissionHoverAll">
          <i class="fas fa-times float-right" v-on:click="permissionHoverAll = false"></i>
          <p v-if="permission === 'all'">{{ $t('folder_show.all_perm') }}</p>
          <p>{{ $t('folder_show.learn_more') }} <a :href="helpCenterUrl" target="_blank">{{ $t('folder_show.check_out') }}</a></p>
        </div>
      </div>

      <div class="nav-tabs-wrapper">
        <ul role="tablist" class="nav nav-tabs">
          <li class="nav-item">
            <router-link :to="{ name: 'shared_folder_show', params: { id: folderId } }" class="nav-link active">
              {{ $t('folder_show.tabs.files') }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'shared_folder_checklist', params: { id: folderId } }" class="nav-link">
              {{ $t('folder_show.tabs.checklist') }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="tab-content">

      <div class="btn-group float-right show-hide-columns" role="group" v-click-outside="closeDropdown" >
        <button class="btn btn-neutral dropdown-toggle"
                v-on:click="openDropdown = !openDropdown">
          {{ $t('records_list.show_hide') }}
        </button>
        <ul class="dropdown-menu" v-if="openDropdown">
          <li class="dropdown-item" @click="toggleColumns('name')">
            <input type="checkbox" :checked="showName" />
            {{ $t('records_list.table.name') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('upload_at')">
            <input type="checkbox" :checked="showUpload" />
            {{ $t('records_list.table.uploaded_at') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('expiration')">
            <input type="checkbox" :checked="showExpiration" />
            {{ $t('records_list.table.expiration') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('status')">
            <input type="checkbox" :checked="showExpirationStatus" />
            {{ $t('records_list.table.expiration_status') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('tags')">
            <input type="checkbox" :checked="showTags" />
            {{ $t('records_list.table.tags') }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('document_type')">
            <input type="checkbox" :checked="showDocumentType" />
            {{ userDocumentTypeTitle }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('product')">
            <input type="checkbox" :checked="showProduct" />
            {{ userProductTitle }}
          </li>
          <li class="dropdown-item" @click="toggleColumns('actions')">
            <input type="checkbox" :checked="showActions" />
            {{ $t('records_list.table.actions') }}
          </li>
          <li>
            <button class="btn btn-primary float-right m-r-10" v-on:click="openDropdown = false">
              {{ $t('records_list.table.save') }}
            </button>
          </li>
        </ul>
      </div>
      <div class="filter">
        <a href="#" class="filter-by btn btn-neutral" @click.prevent='$refs.filterModal.open'>{{ $t('folders_list.filter_share_folder') }}</a>
      </div>
      <div class="filter-results" v-if="hasCustomFilters">
        <strong>{{ $t('records_list.filters.filter_results_for') }}</strong>
        <div v-if="Object.keys(selectedProducts).length > 0">
          <p>
            {{ userProductTitle }}
            <strong>{{Object.values(selectedProducts).map(p => p.name).join(',')}}</strong>
          </p>
        </div>
        <div v-if="Object.keys(selectedProductsCode).length > 0">
          <p>
            {{ userProductTitle }} {{ userProductCode }}
            <strong>{{Object.values(selectedProductsCode).map(p => p.name).join(',')}}</strong>
          </p>
        </div>
        <div v-if="Object.keys(selectedTags).length > 0">
          <p>
            {{ $t('records_list.filters.tags') }}
            <strong>{{Object.values(selectedTags).map(t => t.name).join(',')}}</strong>
          </p>
        </div>
        <div v-if="selectedDocumentTypes.length > 0">
          <p>
            {{ userDocumentTypeTitle }}
            <strong>{{selectedDocumentTypes.map(t => t.name).join(',')}}</strong>
          </p>
        </div>
        <div v-if="Object.keys(selectedExpStatus).length > 0">
          <p>
            {{ $t('records_list.table.expiration_status') }}
            <strong>{{Object.values(selectedExpStatus).map(t => t.name).join(',')}}</strong>
          </p>
        </div>
        <div v-if="selectedExpiration">
          <p>
            {{ $t('records_list.table.expiration') }}
            <strong>{{formatDate(selectedExpiration)}}</strong>
          </p>
        </div>
        <div v-if="selectedRecords.length > 0">
          <p>
            {{ $t('records_list.filename') }}
            <strong>{{selectedRecords.map(r => r.name).join(',')}}</strong>
          </p>
        </div>
        <a href="#" @click="clearFilter">{{ $t('records_list.filters.clear_filters') }}</a>
      </div>
      <div class="table_wrapper" v-if="records.length > 0">
        <div :class="['bulk-container', { 'hide': !isBulkEnabled  }]">
          <span>{{ bulkOpRecords.length }} {{ $t('root.files') }}</span>
          <ul>
            <li>
              <a @click.prevent="$refs.bulkCopyRecords.open(bulkOpRecords)" href="#" class="dropdown-item">
                <i class="fas fa-copy"></i>
                {{ $t('records_list.dropdown.copy') }}
              </a>
            </li>
            <li v-if="permission === 'write' || permission === 'all' ">
              <a @click.prevent="$refs.renameBulkModal.open()" href="#" class="dropdown-item">
                <i class="fas fa-edit"></i>
                {{ $t('records_list.dropdown.rename_files') }}
              </a>
            </li>
            <li v-if="permission === 'all'">
              <a @click.prevent="$refs.bulkTagItemsModal.open(bulkOpRecords)" href="#" class="dropdown-item">
                <i class="fas fa-tag"></i>
                {{ $t('records_list.dropdown.add_tags') }}
              </a>
              <bulk-records-tags-modal ref='bulkTagItemsModal' :shared-folder="sharedFolder" @success='loadSharedFolder()' />
            </li>
            <li  v-if="permission === 'write' || permission === 'all'">
              <a @click.prevent="$refs.deleteBulkModal.open()" href="#" class="dropdown-item">
                <i class="far fa-trash-alt"></i>
                {{ $t('records_list.dropdown.remove') }}
              </a>
            </li>
          </ul>
        </div>
        <table class="table">
          <tr>
            <th><input type='checkbox' @input='selectAll' /></th>
            <th></th>
            <th v-if="showName">{{ $t('records_list.table.file_name') }}</th>
            <th v-if="showUpload">{{ $t('records_list.table.uploaded_at') }}</th>
            <th v-if="showExpiration">{{ $t('records_list.table.expiration') }}</th>
            <th v-if="showExpirationStatus">{{ $t('records_list.table.expiration_status') }}</th>
            <th v-if="showTags">{{ $t('records_list.table.tags') }}</th>
            <th v-if="showDocumentType">{{ userDocumentTypeTitle }}</th>
            <th v-if="showProduct">{{ userProductTitle }}</th>
            <th v-if="showActions">{{ $t('records_list.table.actions') }}</th>
          </tr>
          <tbody>
          <tr v-for='record in records' :key='record.id'>
            <td class="bulk-check">
              <input type='checkbox' v-model='bulkOpRecords' :value='record.id' />
            </td>
            <td class="data-img">
              <img :src="mimeToSrc(record.mime_type)" />
            </td>
            <td v-if="showName">
              <router-link :to="{name: 'shared_record_show', params: { id: record.id, propRecords: records }}">
                {{ record.filename }}
              </router-link>
            </td>
            <td v-if="showUpload">
              {{ formatDate(record.created_at) }}
            </td>
            <td v-if="record.expiration_date && showExpiration">
              {{ formatDate(record.expiration_date) }}
            </td>
            <td v-else-if="showExpiration">
              {{ $t('records_list.table.no_date') }}
            </td>
            <td class="exp-status" v-if="showExpirationStatus">
              <span v-if="record.status === 'current'"
                    data-toggle="tooltip"
                    title="">{{$t('folders_list.up_to_date')}} (V{{record.version}})

              </span>
              <span v-else-if="record.status === 'soon'" class="soon" data-toggle="tooltip" title="">{{$t('folders_list.expires_soon')}} (V{{record.version}})</span>
              <span v-else-if="record.status === 'expired'" class="expired" data-toggle="tooltip" title="">{{$t('folders_list.file_expired')}} (V{{record.version}})</span>
              <span v-else class="no-expiration">{{$t('folders_list.no_exp_date')}} (V{{record.version}})</span>
            </td>
            <td v-if="showTags">
              <div v-if="permission === 'all'">
                <record-tag-manager :record='record' :shared-folder="sharedFolder" @success='loadSharedFolder()'/>
              </div>
              <div v-else>
                <ul v-for="tag in record.tags">
                  <li>
                    {{tag.name}}
                    <span :class="['tag-small-circle', tag.color]"></span>
                  </li>
                </ul>
              </div>
            </td>
            <td v-if="showDocumentType">
              <ul v-for="ci in record.checklist_items">
                <p>{{ci.document_type.name}}</p>
              </ul>
            </td>
            <td v-if="showProduct">
              <ul v-for="ci in record.checklist_items">
                <p>{{ci.product.name}} - {{ci.product.code}}</p>
              </ul>
            </td>
            <td class="dropdown-column" v-if="showActions">
              <div class="dropdown">
                <button aria-expanded="false" aria-haspopup="true" data-toggle="dropdown" type="button"
                        class="btn dropdown-toggle">
                  · · ·
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <ul>
                    <li v-if="permission === 'write' || permission === 'all'">
                      <a @click.prevent='openModal(record, $refs.renameModal)' href='#' class="dropdown-item">
                        <i class="fas fa-edit"></i>
                        {{ $t('records_list.dropdown.rename') }}
                      </a>
                    </li>
                    <li>
                      <a :href="previewUrl(record.location)" class="dropdown-item" :download='record.filename'>
                        <i class="fas fa-download"></i>
                        {{ $t('records_list.dropdown.download') }}
                      </a>
                    </li>
                    <li>
                      <a @click.prevent='$refs.copySharedRecordForm.open(record)' href='#' class="dropdown-item">
                        <i class="fas fa-copy"></i>
                        {{ $t('records_list.dropdown.copy') }}
                      </a>
                    </li>
                    <li v-if="permission === 'write' || permission === 'all'">
                      <a @click.prevent='openModal(record, $refs.deleteModal)' href='#' class="dropdown-item">
                        <i class="fas fa-times"></i>
                        {{ $t('records_list.dropdown.remove') }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="empty-list-wrapper" v-else>
        <div v-if="hasCustomFilters && records.length === 0" class="empty-list-wrapper">
          <img src="../assets/empty_states/shared_with_me.png" />
          <p>{{ $t('records_list.no_files_filters') }} <a @click.prevent="clearFilter" href="#">{{ $t('records_list.clear_filters') }}</a></p>
          <a href="#" class="filter-by btn btn-neutral" @click.prevent='$refs.filterModal.open'>{{ $t('folders_list.filter_by') }}</a>
        </div>
        <div v-if='records.length === 0 && !hasCustomFilters' class="empty-list-wrapper">
          <img src="../assets/empty_states/shared_with_me.png" />
          <p>{{ $t('records_list.empty_message') }}</p>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import _modal from '../components/_modal'
  import _dropzone from '../components/_dropzone'
  import PinkCatSelect from "../components/shared/PinkCatSelect";
  import _folder_subscription from '../components/folders/_subscription_modal'
  import Datepicker from 'vuejs-datepicker'
  import _copy_shared_record_form from '../components/shared/records/_copy_shared_record_form'
  import  status from '../components/checklists/_status'
  import _bulk_copy_record_form from "../components/shared/folders/_bulk_copy_record_form"
  import _bulk_tag_records_modal from "../components/shared/folders/_bulk_tag_records_modal"
  import _record_tag_manager from "../components/shared/folders/_record_tag_manager";

  export default {
    components: {
      PinkCatSelect,
      modal: _modal,
      dropzone: _dropzone,
      datepicker: Datepicker,
      'folder-subscription-modal': _folder_subscription,
      'copy-shared-record-form': _copy_shared_record_form,
      status: status,
      'bulk-copy-records-form': _bulk_copy_record_form,
      'bulk-records-tags-modal': _bulk_tag_records_modal,
      'record-tag-manager': _record_tag_manager
    },
    created() {
      this.store.sendMetrics({name: 'shared_folder', params: this.$route.params, path: this.$route.fullPath})
      this.loadSharedFolder()
      this.loadSharedFolderStats()
    },
    data() {
      return {
        selectedRecord: {},
        selectedRecords: [],
        selectedExpiration: null,
        selectedDocumentTypes: [],
        selectedProducts: {},
        selectedProductsCode: {},
        selectedExpStatus: {},
        selectedTags: {},
        uploadedRecords: [],
        bulkOpRecords: [],
        bulkFilenameRename: null,
        openDropdown: false,
        permissionHoverRead: false,
        permissionHoverWrite: false,
        permissionHoverAll: false
      }
    },
    computed: {
      folderId() {
        return this.$route.params.id
      },
      records() {
        if (!this.state.sharedFolder)
          return []

        return this.state.sharedFolder.records.filter(r => r.id !== null)
      },

      recordsForSelect() {
        let records = []
        if(this.records) {
          this.records.forEach(r => {
            records.push({id: r.id, name: r.filename})
          })
        }
        return records
      },

      documentTypes() {
        let documentTypes = []
        if (this.records) {
          this.records.forEach(r => {
            if (r.checklist_items !== null) {
              r.checklist_items.forEach(ci => {
                let index = documentTypes.find(dt => dt.id === ci.document_type.id);
                if (!index) {
                  documentTypes.push({id: ci.document_type.id, name: ci.document_type.name})
                }
              })
            }
          })
          return documentTypes
        }
      },
      products() {
        const products = {}

        this.records.forEach(r => {
          const items = r.checklist_items || []

          items.forEach(i => {
            products[i.product.id] = i.product
          })
        })

        return Object.values(products)
      },
      tags() {
        const tags = {}

        this.records.forEach(r => {
          const ts = r.tags || []

          ts.forEach(t => {
            tags[t.id] = t
          })
        })

        return Object.values(tags)
      },
      expStatus() {
        const status = {}

        this.records.forEach(r => {
          status[r.status] = { id: r.status, name: this.$t('calendar.' + r.status) }
        })

        return Object.values(status)
      },
      permission() {
        if (this.state.sharedFolder) {
         if(this.state.sharedFolder.share_invite) {
           return this.state.sharedFolder.share_invite.invite_type
         }
        }
      },
      folders() {
        return this.lists.folders || []
      },
      folder() {
        return this.state.folder || {}
      },
      sharedFolder() {
        return this.state.sharedFolder || {}
      },
      folderName() {
        if (this.state.sharedFolder) {
          return this.state.sharedFolder.name
        }
      },
      fullName() {
        if(this.state.sharedFolder) {
          if(this.state.sharedFolder.user) {
            return this.state.sharedFolder.user.full_name
          }
        }
      },
      userDefaults() {
        return this.currentUser.defaults || {}
      },
      sharedColumns() {
        return new Set(this.userDefaults.shared || [])
      },
      showName() {
        return this.sharedColumns.has('name')
      },
      showExpiration() {
        return this.sharedColumns.has('expiration')
      },
      showExpirationStatus() {
        return this.sharedColumns.has('status')
      },
      showDocumentType() {
        return this.sharedColumns.has('document_type')
      },
      showProduct() {
        return this.sharedColumns.has('product')
      },
      showTags() {
        return this.sharedColumns.has('tags')
      },
      showUpload(){
        return this.sharedColumns.has('upload_at')
      },
      showActions() {
        return this.sharedColumns.has('actions')
      },
      isBulkEnabled() {
        return this.bulkOpRecords.length > 0
      },
      helpCenterUrl() {
        if (this.locale == 'de') {
          return 'https://support.relatico.com/de/article/jemand-hat-mir-uber-relatico-einen-ordner-freigegeben-ukcqn7/'
        } else {
          return 'https://support.relatico.com/en/article/someone-shared-a-folder-with-me-via-relatico-17821dn/'
        }
      }
    },
    methods: {
      openModal(record, modal) {
        this.selectedRecord = Object.assign({}, record)
        modal.open()
      },
      renameFile(e) {
        this.store.updateSharedRecord(this.selectedRecord.id, new FormData(e.target)).then(() => {
          this.store.sendMetrics({name: 'renamed_shared_file', params: this.$route.params, path: this.$route.fullPath})
          this.store.getSharedFolder(this.folderId).then(() => {
            this.$refs.renameModal.close()
            this.bulkOpRecords = []
          })
        })
      },
      deleteFile() {
        this.store.destroySharedRecord(this.selectedRecord.id).then(() => {
          this.store.sendMetrics({name: 'remove_shared_file', params: this.$route.params, path: this.$route.fullPath})
          this.store.getSharedFolder(this.folderId).then(() => {
            this.$refs.deleteModal.close()
          })
        })
      },
      uppySuccessCallback(file, res) {
        const params = {
          folder_id: this.folderId,
          filename: file.name,
          mime_type: file.type,
          size: file.size,
          location: res.uploadURL
        }
        return this.store.createSharedRecord(params).then((records) => {
          this.store.sendMetrics({name: 'create_shared_file', params: this.$route.params, path: this.$route.fullPath})
          this.uploadedRecords.push(records.data)
        })
      },
      uppyCompleteCallback(data) {
        let records = data.successful
        if(records.length > 1){
          this.store.createUploadFolderActivity(this.folderId, { event: 'upload_file_shared_folder', count: records.length })
        }else if(records.length === 1){
          let record = this.uploadedRecords[0]
          this.store.createUploadFolderActivity(this.folderId, { event: 'upload_file_shared_folder', record_id: record.id })
        }
        this.store.getSharedFolder(this.folderId).then(() => {
          this.$refs.uploadModal.close()
          this.$refs.dropzone.reset()
        })
      },
      loadFolder() {
        this.store.getFolder(this.folderId)
      },
      loadSharedFolder() {
        this.bulkOpRecords = []
        this.store.getSharedFolder(this.folderId)
      },
      loadSharedFolderStats(){
        this.statStore.getSharedFolders({ 'filters[id]': this.folderId })
      },
      selectName(folder) {
        if(folder.contact_id)
          return `${folder.name} - ${folder.contact.name}`
        else {
          return folder.name
        }
      },
      recordTemplate(item) {
        return item.name
      },
      documentTypeTemplate(item) {
        return item.name
      },
      productCodeTemplate(item){
        return item.code
      },
      clearFilter() {
        this.hasCustomFilters = false
        this.$refs.filterModal.close()
        this.selectedRecords = []
        this.selectedDocumentTypes = []
        this.selectedProducts = {}
        this.selectedProductsCode = {}
        this.selectedTags = {}
        this.selectedExpiration = null
        this.selectedExpStatus = {}
        this.store.getSharedFolder(this.folderId)
      },
      filterRecords() {
        let params = {}
        if (this.selectedRecords.length > 0)
          params.record_id = this.selectedRecords.map(r => r.id)

        if (this.selectedDocumentTypes.length > 0)
          params.document_type_id = this.selectedDocumentTypes.map(r => r.id)

        if (Object.keys(this.selectedProducts).length > 0)
          params.product_id = Object.values(this.selectedProducts).map(r => r.id)

        if (Object.keys(this.selectedProductsCode).length > 0)
          params.product_id = Object.values(this.selectedProductsCode).map(r => r.id)

        if (Object.keys(this.selectedTags).length > 0)
          params.tag_id = Object.values(this.selectedTags).map(r => r.id)

        if (this.selectedExpiration)
          params.expiration_date = this.selectedExpiration

        if (this.selectedExpStatus)
          params.status = Object.values(this.selectedExpStatus).map(r => r.id)

        this.$refs.filterModal.close()
        this.hasCustomFilters = true
        this.store.getSharedFolder(this.folderId, params)
      },
      clearOptionForRecords() {
        this.selectedRecords = []
      },
      clearOptionForExpStatus() {
        this.selectedExpStatus = {}
      },
      clearOptionForTags() {
        this.selectedTags = {}
      },
      clearOptionForDocumentType() {
        this.selectedDocumentTypes = []
      },
      clearOptionForProducts() {
        this.selectedProducts = {}
      },
      clearOptionForProductsCode() {
        this.selectedProductsCode = {}
      },
      addRecord(item) {
        if (!this.selectedRecords.includes(item)) {
          this.selectedRecords.push(item)
        }
      },
      removeRecord(item) {
        let index = this.selectedRecords.indexOf(item)
        if(index > -1) {
          this.selectedRecords.splice(index, 1)
        }
      },
      addDocumentType(item) {
        if (!this.selectedDocumentTypes.includes(item)) {
          this.selectedDocumentTypes.push(item)
        }
      },
      removeDocumentType(item) {
        let index = this.selectedDocumentTypes.indexOf(item)
        if(index > -1) {
          this.selectedDocumentTypes.splice(index, 1)
        }
      },
      addProduct(item) {
        this.selectedProducts = Object.assign({}, this.selectedProducts, { [item.id]: item })
      },
      removeProduct(item) {
        this.$delete(this.selectedProducts, item.id)
      },
      addProductCode(item) {
        this.selectedProductsCode = Object.assign({}, this.selectedProductsCode, { [item.id]: item })
      },
      removeProductCode(item) {
        this.$delete(this.selectedProductsCode, item.id)
      },
      addTag(item) {
        this.selectedTags = Object.assign({}, this.selectedTags, { [item.id]: item })
      },
      removeTag(item) {
        this.$delete(this.selectedTags, item.id)
      },
      toggleColumns(column) {
        const newSharedColumn = this.sharedColumns

        this.sharedColumns.has(column) ? newSharedColumn.delete(column) : newSharedColumn.add(column)

        const newDefaults = Object.assign({}, this.currentUser.defaults, { shared: Array.from(newSharedColumn) })

        this.store.updateUserProfile({ user: { defaults: newDefaults } }).then(() => {
          this.store.getCurrentUser()
        })
      },
      closeDropdown() {
        this.openDropdown = false
      },
      addExpStatus(item) {
        this.selectedExpStatus = Object.assign({}, this.selectedExpStatus, { [item.id]: item })
      },
      removeExpStatus(item) {
        this.$delete(this.selectedExpStatus, item.id)
      },
      selectAll(e) {
        if (e.target.checked) {
          this.bulkOpRecords = this.records.map(r => r.id)
        } else {
          this.bulkOpRecords = []
        }
      },
      bulkRenameFiles() {
        this.store.bulkRenameFiles(this.bulkFilenameRename, this.bulkOpRecords, this.folderId).then(() => {
          this.store.sendMetrics({name: 'bulk_renamed_shared_file', params: this.$route.params, path: this.$route.fullPath})
          this.store.getSharedFolder(this.folderId).then(() => {
            this.$refs.renameBulkModal.close()
          })
        })
        this.loadSharedFolder()
      },
      deleteBulkFile() {
        this.store.bulkDeleteFiles(this.bulkOpRecords, this.folderId, this.sharedFolder.organization_id).then(() => {
          this.store.sendMetrics({name: 'bulk_delete_shared_file', params: this.$route.params, path: this.$route.fullPath})
          this.store.getSharedFolder(this.folderId).then(() => {
            this.$refs.deleteBulkModal.close()
          })
        })
        this.loadSharedFolder()
      },
      checklistStats(item) {
        if(this.stats.shared_folders) {
          const stats = this.stats.shared_folders.find(f => f.id == this.folderId)
          if (stats) {
            return {total: stats.total_checklist_items, checked: stats.checked_checklist_items}
          } else {
            return {total: 0, checked: 0}
          }
        } else {
          return {total: 0, checked: 0}
        }
      },
      permissionType() {
        if (this.permission == 'read') {
          this.permissionHoverRead = true
        } else if (this.permission == 'write') {
          this.permissionHoverWrite = true
        } else if (this.permission == 'all') {
          this.permissionHoverAll = true
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import '../styles/tags'
  .filter-all-records
    form
      label
        display: block
  table
    tr
      ul
        padding-left: 0
        list-style: none
        li
          line-height: 23px
  .shared-folder-status
    clear: both
    display: flex
    align-items: center
    margin-bottom: 20px
    label
      font-size: 16px
      margin-right: 20px
      margin-bottom: 0
    .completeness
      width: 50%
  .bulk-container
    background-color: #EBF4FE
    display: flex
    align-items: center
    padding: 8px 0
    border-radius: 3px
    float: left
    width: 100%
    margin-top: 20px
    > span
      padding-left: 10px
    ul
      list-style: none
      padding: 0
      margin: 0
      display: flex
      li
        position: relative
        a
          &:hover, &:visited, &:focus
            background: none
            text-decoration: underline
        .bulk-tags-wrapper
          position: absolute
          top: 0
          right: 0
    &.hide
      display: none
  .show-hide-columns
    margin-left: 0
  .permission-block
    margin: 10px 20px 0 0
    position: relative
    > p
        color: #686868
        font-size: 16px
        strong
          margin-right: 5px
        i
          font-size: 20px
          vertical-align: bottom
  .info-permission
    background-color: #414141
    border-radius: 3px
    position: absolute
    top: 50px
    left: 19px
    color: #fff
    font-family: Quicksand
    width: 300px
    z-index: 100
    &:after
      bottom: 100%
      left: 50%
      border: solid transparent
      content: ""
      height: 0
      width: 0
      position: absolute
      pointer-events: none
      border-color: rgba(65, 65, 65, 0)
      border-bottom-color: #414141
      border-width: 25px
      margin-left: -25px
    a
      text-decoration: underline
      color: #fff
      font-weight: bold
    p
      padding: 10px
      margin-bottom: 0
    .fa-times
      font-size: 16px
      padding: 5px 10px
      cursor: pointer
</style>
